var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5L5.5 1.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5L10.5 1.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6241 14.5H3.37608C3.15956 14.4961 2.95071 14.4191 2.78337 14.2817C2.61603 14.1442 2.5 13.9543 2.45408 13.7427L1.02875 6.74267C0.990587 6.59897 0.985305 6.44852 1.01329 6.3025C1.04128 6.15648 1.10182 6.01864 1.19041 5.89924C1.279 5.77984 1.39337 5.68194 1.525 5.61282C1.65664 5.5437 1.80216 5.50514 1.95075 5.5H14.0494C14.198 5.50514 14.3435 5.5437 14.4752 5.61282C14.6068 5.68194 14.7212 5.77984 14.8097 5.89924C14.8983 6.01864 14.9589 6.15648 14.9869 6.3025C15.0149 6.44852 15.0096 6.59897 14.9714 6.74267L13.5461 13.7427C13.5002 13.9543 13.3841 14.1442 13.2168 14.2817C13.0495 14.4191 12.8406 14.4961 12.6241 14.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping-basket.115a6c6a3848d6b692fb93acd66c99bb.svg";
export { ForwardRef as ReactComponent };